<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable width="auto">
      <v-card>
        <v-toolbar flat dark color="primary" class="max-height">
          <v-toolbar-title v-if="modulo && modulo.modulo"> Modulo: {{ modulo.modulo.nombre }} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row class="pa-3">
            <v-spacer></v-spacer>
            <v-btn v-if="visible" class="float-right" color="amber" @click="openViewReinstatement" rounded small>
              <v-icon class="mr-2">mdi-plus-outline</v-icon> Reincorporar Estudiante
            </v-btn>
          </v-row>
          <p v-html="datamsg"></p>
          <v-skeleton-loader :loading="!inscripciones.length" transition="scale-transition" height="300" type="table">
            <v-row>
              <v-col cols="12">
                <v-badge color="success" left overlap :content="inscripciones.length">
                  <v-data-table
                    v-model="selected"
                    :headers="inscripcionesHeader"
                    :items-per-page="-1"
                    :items="inscripciones"
                    :search="search"
                    item-key="id"
                    sort-by="full_name">
                    <template v-slot:top>
                      <v-text-field
                        outlined
                        dense
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar en la lista"
                        hide-details></v-text-field>
                    </template>

                    <template #[`item.full_name`]="{ item }">
                      {{ item.estudiante.nombres }} {{ item.estudiante.primer_apellido }}
                      {{ item.estudiante.segundo_apellido }}
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" @click="viewDetailStudent(item)">
                            mdi-eye
                          </v-icon>
                        </template>
                        Detalle
                      </v-tooltip>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="success" @click="openWhatsapp(item)"
                            >mdi-whatsapp
                          </v-icon>
                        </template>
                        Enviar Credenciales
                      </v-tooltip>
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="orange" @click="reinstatementStudent(item)"> mdi-account-convert</v-icon>
                        </template>
                        Marcar como Reincorporacion
                      </v-tooltip> -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="primary" @click="freezeStudent(item)">
                            mdi-timer</v-icon
                          >
                        </template>
                        Congelar Estudiante
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="red" @click="withdrawStudent(item)">
                            mdi-bus-stop-uncovered</v-icon
                          >
                        </template>
                        Retirar Estudiante
                      </v-tooltip>
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="success" @click="setHowEnrolled(item)"> mdi-account-switch</v-icon>
                        </template>
                        Marcar como inscrito
                      </v-tooltip> -->

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-2" v-bind="attrs" v-on="on" color="red" @click="deleteStudent(item)">
                            mdi-delete</v-icon
                          >
                        </template>
                        eliminar Estudiante
                      </v-tooltip>
                    </template>
                    <template v-slot:[`item.moodle_actions`]="{ item }">
                      <!-- <v-tooltip bottom v-if="!item.disable">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ma-0" v-bind="attrs" v-on="on" color="primary" @click="editUserMoodle(item)"> mdi-pencil</v-icon>
                        </template>
                        Editar datos de Estudiante en Moodle
                      </v-tooltip> -->
                      <v-switch
                        class="ma-0"
                        @change="actionSwitch(item)"
                        v-model="item.moodle_status"
                        :disabled="item.disable"
                        :title="
                          item.disable
                            ? 'Estudiante no Encontrado en Moodle'
                            : ' Activar / Desactivar Estudiante en Moodle'
                        "
                        color="primary"></v-switch>
                    </template>
                  </v-data-table>
                </v-badge>
              </v-col>
            </v-row>
          </v-skeleton-loader>
          <p class="text-center ma-0 pa-0 red--text">
            <small> {{ msgerr }} </small>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded outlined color="primary" @click="closeDialog"> <v-icon> mdi-close</v-icon> cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <details-ins ref="refDetailIns"></details-ins>
    <update-user-moodle ref="refUserUpdateMoodle"></update-user-moodle>
    <reinstatement-view
      ref="refReinstatementView"
      :programa="programa"
      :inscritosByPrograma="inscritosByPrograma"
      @increase="increaseEnroll" />
    <send-whatsapp-dialog ref="refWhatsapp"></send-whatsapp-dialog>
  </v-row>
</template>
<script>
// This view lists the students enrolled in a module of a specific program,
//  for which it receives the program and the module as parameters (props)
import xaxios from '@/xaxios';
import { parseInscripcionModuloEstado } from '@/components/Utils.js';
import UpdateUserMoodle from '@/components/vuetify/UpdateUserMoodle.vue';
import ReinstatementView from './ReinstatementView.vue';
import SendWhatsappDialog from '@/components/vuetify/SendWhatsappDialog.vue';
import DetailsIns from '../Inscripcion/DetailsIns.vue';
export default {
  components: { UpdateUserMoodle, ReinstatementView, SendWhatsappDialog, DetailsIns },
  props: ['programa', 'inscritosByPrograma', 'plataformas'],
  data() {
    return {
      api_rest: process.env.VUE_APP_API_REST,
      // api_rest_moodle: process.env.UE_APP_API_REST_MOODLE,
      search: '',
      modulo: null,
      dialog: false,
      visible: false,
      selected: [],
      inscrito: null,
      inscripciones: [],
      inscripcionesHeader: [
        { text: 'Id Inscripcion', value: 'estudiante.id' },
        { text: 'Nombre Completo', value: 'full_name' },
        { text: 'N° Doc', value: 'estudiante.numero_documento' },
        { text: 'Email', value: 'estudiante.email' },
        { text: 'Telefono', value: 'estudiante.telefono1' },
        { text: 'Estado', value: 'status' },
        { text: 'Opciones', value: 'actions', sortable: false },
        { text: 'Moodle Opciones', value: 'moodle_actions', sortable: false },
      ],
      exists_course_moodle: false,
      enrolments: [],

      datamsg: '',
      plataforma: {},
      msgerr: '',
    };
  },

  methods: {
    showThisView(modulo, xplataforma) {
      this.modulo = modulo;
      this.dialog = true;
      if (xplataforma) this.plataforma = xplataforma;
      this.loadData();
    },
    editUserMoodle(inscripcion) {
      this.$refs.refUserUpdateMoodle.showThisView(inscripcion.estudiante.id, inscripcion);
    },
    viewDetailStudent(ins) {
      this.$refs.refDetailIns.showThisView(ins.estudiante_id, ins.inscripcion_id);
    },
    openViewReinstatement() {
      this.$refs.refReinstatementView.showThisView(this.inscripciones, this.modulo);
    },
    increaseEnroll(item) {
      let student = {};
      student.inscripcion_modulo_id = item.programa_modulo_id;
      student.nota_recuperatorio = item.nota_recuperatorio;
      student.tipo_ingreso_str = item.tipo_ingreso_str;
      student.fecha_registro = item.fecha_registro;
      student.inscripcion_id = item.inscripcion_id;
      student.tipo_ingreso = item.tipo_ingreso;
      student.observacion = item.observacion;
      student.nota_final = item.nota_final;
      student.estado = item.estado_inscripcion;
      student.status = 'REINSCORPORADO';
      student.disable = this.checkStatusMoodleDisable(item);
      student.moodle_status = this.checkStatusMoodle(item);
      student = Object.assign(item, student);
      this.inscripciones.push(student);
      this.modulo.inscritos++;
      this.$emit('increase', this.modulo);
    },
    openWhatsapp({ estudiante }) {
      let { usuario_moodle, clave_moodle } = estudiante;
      this.$refs.refWhatsapp.showThisView(
        estudiante,
        estudiante.telefono1,
        `Credenciales de acceso:\n usuario_moodle: ${usuario_moodle}\n clave moodle: ${clave_moodle}`,
      );
    },

    async actionSwitch(inscripcion) {
      this.msgerr = '';
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }
      let sms = !inscripcion.moodle_status ? 'Desactivar Estudiante en Moodle' : 'Activar Estudiante en Moodle';
      if (await this.$root.$confirm.open(sms, 'Estas seguro?', { color: 'orange', width: '50%' })) {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.plataforma.id
        }/enrolment/status`;
        const formData = {
          username: inscripcion.estudiante.usuario_moodle,
          course_id: this.modulo.course_id,
          current_status: inscripcion.moodle_status,
          desired_status: inscripcion.moodle_status,
        };
        // window.console.log(JSON.stringify(formData), url);
        xaxios
          .post(url, formData)
          .then(() => {
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${inscripcion.moodle_status ? 'ACTIVADO' : 'SUSPENDIDO'} EN MOODLE: Estudiante ${std.nombres} ${
                std.primer_apellido
              } ${std.segundo_apellido}`,
              { color: 'success' },
            );
            inscripcion.moodle_status = formData.current_status == 1;
            /*this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) inscripcion.moodle_status = !inscripcion.moodle_status;
              return student;
            });*/
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
    },
    loadData() {
      this.msgerr = '';
      // window.console.log('jejejeje', this.plataforma.id);
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }

      if (this.modulo.course_id) {
        this.exists_course_moodle = true;
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.plataforma.id
        }/course/id/${this.modulo.course_id}/enrolment`;
        window.console.log('URL>>>', url);
        xaxios
          .get(url)
          .then(({ data: { enrolments } }) => {
            this.enrolments = enrolments;
            this.loadInscritos();
          })
          .catch(() => {
            this.$root.$notify.show(`ERROR: no se pudo obtener la informacion`, { color: 'red', y: 'top' });
          });
      } else {
        this.loadInscritos();
        this.$root.$notify.show(`ERROR: El modulo no tiene un course id`, { color: 'red', y: 'top' });
      }
    },
    loadInscritos() {
      const url = `${this.api_rest}/esam/inscripcion/modulo/id/${this.modulo.id}`;
      xaxios
        .get(url)
        .then(({ data }) => {
          this.visible = true;
          if (data.inscripciones) {
            data.inscripciones.forEach((item) => {
              let student = {};
              student.inscripcion_modulo_id = item.programa_modulo_id;
              student.nota_recuperatorio = item.nota_recuperatorio;
              student.tipo_ingreso_str = item.tipo_ingreso_str;
              student.fecha_registro = item.fecha_registro;
              student.inscripcion_id = item.inscripcion_id;
              student.tipo_ingreso = item.tipo_ingreso;
              student.observacion = item.observacion;
              student.nota_final = item.nota_final;
              student.estado = item.estado_inscripcion;
              student.status = parseInscripcionModuloEstado(student);
              student.disable = this.checkStatusMoodleDisable(item);
              student.moodle_status = this.checkStatusMoodle(item);
              student = Object.assign(item, student);
              this.inscripciones.push(student);
            });
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    checkStatusMoodle({ estudiante: { usuario_moodle } }) {
      let estado = false;
      if (this.modulo.course_id) {
        this.enrolments.forEach(({ user, status }) => {
          if (usuario_moodle == user.username) estado = status ? false : true;
        });
      }
      return estado;
    },
    checkStatusMoodleDisable({ estudiante: { usuario_moodle } }) {
      let contador = 0;
      if (this.modulo.course_id) {
        this.enrolments.forEach(({ user }) => (usuario_moodle == user.username ? contador++ : null));
      }
      return contador > 0 ? false : true;
    },

    async active_moodle(inscripcion) {
      this.msgerr = '';
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }
      if (await this.$root.$confirm.open('Activar Estudiante', 'Estas seguro?', { color: 'orange', width: '50%' })) {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.plataforma.id
        }/enrolment/status`;
        xaxios
          .post(url, {
            username: inscripcion.estudiante.usuario_moodle,
            course_id: this.modulo.course_id,
            current_status: 1,
            desired_status: 0,
          })
          .then(({ data }) => {
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) inscripcion.moodle_status = true;
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Activado en Moodle`,
              {
                color: 'success',
              },
            );
          })
          .catch(() => {
            // window.console.log('error ', err);
          });
      }
    },
    async inactive_moodle(inscripcion) {
      this.msgerr = '';
      if (!this.plataforma.id) {
        this.plataformaprograma();
      }
      if (await this.$root.$confirm.open('Suspender Estudiante', 'Estas seguro?', { color: 'orange', width: '50%' })) {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.plataforma.id
        }/enrolment/status`;
        xaxios
          .post(url, {
            username: inscripcion.estudiante.usuario_moodle,
            course_id: this.modulo.course_id,
            current_status: 0,
            desired_status: 1,
          })
          .then(({ data }) => {
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) inscripcion.moodle_status = false;
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Suspendido En Curso de Moodle`,
              {
                color: 'success',
              },
            );
          })
          .catch(() => {
            // window.console.log('error ', err);
          });
      }
    },
    async reinstatementStudent(inscripcion) {
      if (await this.$root.$confirm.open('Reincoporar Estudiante', 'Estas seguro?', { color: 'orange' })) {
        let url = `${this.api_rest}/esam/inscripcion/modulo/tipo`;
        // let formData = { inscripcion_modulo_id: inscripcion.inscripcion_modulo_id, tipo_ingreso: 1 };
        // window.console.log('reinstatementStudent ', inscripcion, JSON.stringify(formData), url);
        xaxios
          .post(url, { inscripcion_modulo_id: inscripcion.id, tipo_ingreso: 1 })
          .then(({ data }) => {
            inscripcion.tipo_ingreso = +inscripcion.tipo_ingreso ? 0 : 1;
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) student.status = parseInscripcionModuloEstado(inscripcion);
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Reincoporado`,
              { color: 'success' },
            );
          })
          .catch(() => {
            // window.console.log('error ', err);
          });
      }
    },

    async freezeStudent(inscripcion) {
      if (await this.$root.$confirm.open('Congelar Estudiante', 'Estas seguro?', { color: 'orange' })) {
        let url = `${this.api_rest}/esam/inscripcion/modulo/status`;
        xaxios
          .post(url, { inscripcion_modulo_id: inscripcion.id, estado_inscripcion_modulo: 2 })
          .then(({ data }) => {
            inscripcion.estado = 2;
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) student.status = parseInscripcionModuloEstado(inscripcion);
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Congelado`,
              { color: 'success' },
            );
          })
          .catch(() => {
            // window.console.log('error ', err);
          });
      }
    },

    async withdrawStudent(inscripcion) {
      if (await this.$root.$confirm.open('Retirar Estudiante', 'Estas seguro?', { color: 'orange' })) {
        let url = `${this.api_rest}/esam/inscripcion/modulo/status`;
        xaxios
          .post(url, { inscripcion_modulo_id: inscripcion.id, estado_inscripcion_modulo: 1 })
          .then(({ data }) => {
            inscripcion.estado = 1;
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) student.status = parseInscripcionModuloEstado(inscripcion);
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Retirado`,
              { color: 'success' },
            );
          })
          .catch(({ response: { data } }) => this.$root.$notify.show(`ERROR: ${data.error}`, { color: 'danger' }));
      }
    },

    async setHowEnrolled(inscripcion) {
      if (await this.$root.$confirm.open('Retirar Estudiante', 'Estas seguro?', { color: 'orange' })) {
        let url = `${this.api_rest}/esam/inscripcion/modulo/status`;
        xaxios
          .post(url, { inscripcion_modulo_id: inscripcion.id, estado_inscripcion_modulo: 0 })
          .then(({ data }) => {
            inscripcion.estado = 0;
            this.inscripciones = this.inscripciones.map((student) => {
              if (student === inscripcion) student.status = parseInscripcionModuloEstado(inscripcion);
              return student;
            });
            let std = inscripcion.estudiante;
            this.$root.$notify.show(
              `${data.result}: Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Inscrito`,
              { color: 'success' },
            );
          })
          .catch(({ response: { data } }) => this.$root.$notify.show(`ERROR: ${data.error}`, { color: 'danger' }));
      }
    },

    async deleteStudent(inscripcion) {
      if (await this.$root.$confirm.open('Eliminar Estudiante', 'Estas seguro?', { color: 'orange' })) {
        let std = inscripcion.estudiante;
        let url = `${this.api_rest}/esam/inscripcion/modulo/id/${inscripcion.id}`;
        xaxios
          .delete(url)
          .then(() => {
            this.inscripciones = this.inscripciones.filter((item) => item !== inscripcion);
            this.$root.$notify.show(
              `Estudiante ${std.nombres} ${std.nombres} ${std.primer_apellido} ${std.segundo_apellido} Eliminado`,
              { color: 'orange' },
            );
          })
          .catch(() => {});
      }
    },

    confirmSelected() {},

    closeDialog() {
      this.dialog = false;
      this.visible = false;
      this.search = '';
      this.selected = [];
      this.inscrito = null;
      this.inscripciones = [];
      this.exists_course_moodle = false;
      this.enrolments = [];
    },

    plataformaprograma() {
      let plataforma_id = this.programa.plataforma_id;
      this.plataforma = this.plataformas.find((x) => x.id == plataforma_id);
      this.datamsg = `<b>Plataforma</b>: ${this.plataforma.nombre}`;
    },
  },
};
</script>
<style scoped>
.v-badge,
.v-badge__badge {
  display: block;
  line-height: 1;
}
</style>